<template>
  <range
    class="pagoda-date-range"
    :range-start-focus="rangeStartFocus"
    :range-end-focus="rangeEndFocus"
    :range-separator="rangeSeparator"
    :clearable="clearable"
    @clear="$emit('input', [])"
  >
    <el-date-picker
      slot="range-start"
      v-bind="picker1Attrs"
      @input="$emit('input', [arguments[0], value[1]])"
      @focus="rangeStartFocus = true"
      @blur="rangeStartFocus = false"
    >
    </el-date-picker>
    <el-date-picker
      slot="range-end"
      prefix-icon="''"
      v-bind="picker2Attrs"
      @input="$emit('input', [value[0], arguments[0]])"
      @focus="rangeEndFocus = true"
      @blur="rangeEndFocus = false"
    >
    </el-date-picker>
  </range>
</template>

<script>
import { getEmptyArray, getEmptyObject } from '../../utils'
import Range from './range'

import moment from 'moment'

export default {
  name: 'DateRange',
  components: {
    Range
  },
  props: {
    value: {
      type: null,
      default: getEmptyArray
    },
    rangeSeparator: {
      type: String,
      default: '至'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'month'
    },
    picker1Props: {
      type: Object,
      default: getEmptyObject
    },
    picker2Props: {
      type: Object,
      default: getEmptyObject
    },
    valueFormat: {
      type: String,
      default() {
        return {
          month: 'yyyy-MM',
          year: 'yyyy',
          date: 'yyyy-MM-dd'
        }[this.type]
      }
    }
  },
  computed: {
    picker1Attrs() {
      return {
        type: this.type,
        valueFormat: this.valueFormat,
        placeholder: this.startPlaceholder,
        value: this.value[0],
        clearable: false,
        ...this.picker1Props,
        pickerOptions: this.getPickerOptions('startPicker')
      }
    },
    picker2Attrs() {
      return {
        type: this.type,
        valueFormat: this.valueFormat,
        placeholder: this.endPlaceholder,
        value: this.value[1],
        clearable: false,
        ...this.picker2Props,
        pickerOptions: this.getPickerOptions('endPicker')
      }
    },
    startPlaceholder() {
      return {
        month: '开始月份',
        year: '开始年份',
        date: '开始日期'
      }[this.type]
    },
    endPlaceholder() {
      return {
        month: '结束月份',
        year: '结束年份',
        date: '结束日期'
      }[this.type]
    }
  },
  data() {
    return {
      rangeStartFocus: false,
      rangeEndFocus: false
    }
  },
  methods: {
    getPickerOptions(picker) {
      const pickerOptions =
        picker === 'startPicker' ? this.picker1Props.pickerOptions : this.picker2Props.pickerOptions

      return {
        ...pickerOptions,
        disabledDate: pickerTime => {
          const isDisabledDate =
            pickerOptions && pickerOptions.disabledDate
              ? pickerOptions.disabledDate(pickerTime)
              : false
          const [startTime, endTime] = this.value

          let time = picker === 'startPicker' ? endTime : startTime

          if (!time) return isDisabledDate

          const _pickerTime = moment(pickerTime).format()

          time = moment(time, this.valueFormat.toUpperCase()).format()

          return (
            (picker === 'startPicker' ? _pickerTime > time : _pickerTime < time) || isDisabledDate
          )
        }
      }
    }
  }
}
</script>
